import { render, staticRenderFns } from "./LmListV2.vue?vue&type=template&id=21492587&scoped=true&"
import script from "./LmListV2.vue?vue&type=script&lang=js&"
export * from "./LmListV2.vue?vue&type=script&lang=js&"
import style0 from "./LmListV2.vue?vue&type=style&index=0&id=21492587&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21492587",
  null
  
)

export default component.exports